var React = require("react");
var ReactDOM = require('react-dom');
var $ = require('jquery');
var _ = require('underscore');

//React.initializeTouchEvents(true);

// Stylesheets
//require("./style/common.less");
require("./style/style.less");

// Components
var JobHeader = require('./components/job_header');
var ApplyForm = require('./components/apply_form');
var DisabledView = require('./components/disabled_view');

// Stores
var LanguageStore = require('./stores/language_store');

var job_data = $("input[name='job_data']").val();
	job_data = (job_data != null && job_data != '' && job_data != 'null') ? JSON.parse(job_data) : null;
var form_data = JSON.parse($("input[name='form_data']").val());

// Env info	
var env_info = $("input[name='env_info']").val();
	env_info = (env_info != null && env_info != '' && env_info != 'null') ? JSON.parse(env_info) : null;

var language = JSON.parse($("input[name='language']").val());

LanguageStore.load(language);

var env_name = $("input[name='env']").val();

//var body_bg_url = (env_info.settings.body_bg_id != '') ? '/bg/'+env_name+'/'+env_info.settings.body_bg_id : '';
var body_bg_url = (env_info.settings.body_bg_id != '') ? 'https://images.searchsoftware.nl/'+env_name+'/bg/'+env_info.settings.body_bg_id : '';
		
if(body_bg_url != ''){
 	//wrapperStyle.backgroundImage = 'url('+body_bg_url+')';
 	//$('body').css('background', 'url('+body_bg_url+') no-repeat center center fixed');
 	
 	// Desktop
 	if($(window).width() > 600){
 		$('body').css('background', 'url('+body_bg_url+') no-repeat center center fixed');
 		$('body').css('background-size', ($(window).width()+400)+'px');
 	} else {
	 	//$('body').css('background', 'url('+body_bg_url+') center no-repeat');
 	}
}

// Colors
function hexToRgb(hex) {
    var bigint = parseInt(hex, 16);
    var r = (bigint >> 16) & 255;
    var g = (bigint >> 8) & 255;
    var b = bigint & 255;

    return r + "," + g + "," + b;
}

var customStyle = $('<style></style>');

if(env_info.name === 'careerscout'){
	env_info.default_job_board_font = 'Raleway';
}

// Load font
if(typeof env_info.default_job_board_font != 'undefined' && env_info.default_job_board_font != ''){
	var font = env_info.default_job_board_font;
	
	$("<link href='https://fonts.googleapis.com/css?family="+font.replace(/ /ig, '+')+"' rel='stylesheet' type='text/css'>")
	.appendTo($('head'));
	
	customStyle.append("body { font-family:'"+font+"'; }");
	customStyle.append("input[type='submit'], button, a { font-family:'"+font+"'; }");
	customStyle.append("input[type='text'] { font-family:'"+font+"'; }");

// Default font
} else {
	var font = 'Tinos';
	
	$("<link href='https://fonts.googleapis.com/css?family="+font+"' rel='stylesheet' type='text/css'>")
	.appendTo($('head'));
	
	customStyle.append("body { font-family:'"+font+"'; }");
	customStyle.append("input[type='submit'], button, a { font-family:'"+font+"'; }");
}

if(typeof env_info.colors != 'undefined'){
	_.each(env_info.colors, function(color, key){
		//console.log(color, key);
		
		
		// Apply button
		if(key === 'job_view_apply_button_text_color'){
			customStyle.append(".apply-form .content .section table tr td input[type='submit'] { color:"+color+"; }");
		}
		
		if(key === 'job_view_apply_button_text_color_hover'){
			customStyle.append(".apply-form .content .section table tr td input[type='submit']:hover { color:"+color+"; }");
		}
		
		if(key === 'job_view_apply_button_background'){
			customStyle.append(".apply-form .content .section table tr td input[type='submit'] { background:"+color+"; }");
		}
		
		if(key === 'job_view_apply_button_background_hover'){
			customStyle.append(".apply-form .content .section table tr td input[type='submit']:hover { background:"+color+"; }");
		}
		
		if(key === 'job_view_apply_button_border'){
			customStyle.append(".apply-form .content .section table tr td input[type='submit'] { border:1px solid "+color+"; }");
		}
		
		if(key === 'job_view_apply_button_border_hover'){
			customStyle.append(".apply-form .content .section table tr td input[type='submit']:hover { border:1px solid "+color+"; }");
		}
	
	});
}

// Custom font from file
if(env_info.name === 'htnk' || env_info.name === 'jb'){
	customStyle.append("body { text-rendering: optimizeLegibility; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;}");
	customStyle.append("@font-face { font-family:'HTNK Heureka'; font-weight:normal; src: url('/assets/fonts/HTNK Heureka Condensed/HTNK_Heureka_Condensed.ttf') }");
	customStyle.append("@font-face { font-family:'HTNK Heureka'; font-weight:bold; src: url('/assets/fonts/HTNK Heureka Bold/HTNK_Heureka_Bold.ttf') }");
	customStyle.append("body { font-family:'HTNK Heureka'; font-size:18px; }");
	customStyle.append("input[type='submit'], button, a { font-family:'HTNK Heureka'; }");
	
	$('body').css('background', '#fff');
	
	customStyle.append("body { background:#fff; }");
	customStyle.append(".job-header { background:rgba(235,235,229,.90); border-bottom:9px solid #000; }");
	
	//customStyle.append(".apply-form { width:450px; }");
	customStyle.append(".apply-form .content { padding:0px 30px 30px 30px; }");
	customStyle.append(".apply-form .content .section h3 { font-size:22px; border-bottom:2px solid #000; padding-bottom: 10px; margin-top: 30px }");
	
	// input fields
	customStyle.append(".apply-form .content .section table tr td input[type='text'] { border:1px solid rgba(235,235,229,.95); font-weight:500; font-family:arial; border-radius:0px; background:rgba(235,235,229,.95); }");
	
	// textarea
	customStyle.append(".apply-form .content .section textarea { border:1px solid rgba(235,235,229,.95); font-weight:500; font-family:arial; border-radius:0px; background:rgba(235,235,229,.95); padding:10px;}");
	
	
	// submit button
	customStyle.append(".apply-form .content .section table tr td input[type='submit'] { background:#000; color:#fff; font-size:21px; font-weight:bold; padding:10px 15px 7px; }");
	customStyle.append(".apply-form .content .section table tr td input[type='submit']:hover { background:#fbe733; color:#000; }");
	customStyle.append(".apply-form .content .section table tr td input[type='submit']:hover { background:#fbe733; color:#000; border:1px solid #fbe733; }");
	
	// Agree message
	customStyle.append(".apply-form .content .section.agree-message span { border-bottom: 3px solid #fbe733; line-height: 28px; }");
	
	// cancel button
	customStyle.append(".apply-form .content .section table tr td .cancel { display:none; }");
	
	// hide linkedin button
	customStyle.append(".connect-linkedin-button { display:none; }");
	
	// desktop
	customStyle.append("@media screen and (min-width: 600px ) { .apply-form { width:450px; } }");
	customStyle.append("@media screen and (min-width: 600px ) { .apply-form .content { border:3px solid #000; padding:0px 30px 30px 30px; } }");
	
	// video button
	
	
	customStyle.append(".apply-form .content .section table tr td.video-input .toggle-video-recorder-button .text { vertical-align:text-bottom;}");
}

if(env_info.name === 'fortasolutions'){
	customStyle.append('.apply-form .content .section.apply input[type="submit"] { width:auto; padding:12px 32px 12px 32px; border-radius:100px 100px 100px 100px; background:#e0bf89; border:1px solid #e0bf89; font-size:22px; box-shadow: 2px 2px 2px #dddddd; font-family:"Ubuntu", Sans-serif !important; }');
	customStyle.append(".apply-form .content .section.apply input[type='submit']:hover { background:#6d8c7d; border:1px solid #e0bf89; }");
	customStyle.append(".apply-form .content .section.apply a.cancel { border-radius:100px 100px 100px 100px; font-size:18px; }");
	customStyle.append(".apply-form .content h3 { font-weight:normal; }");
	customStyle.append(".apply-form .content { border-radius:25px; }");
	customStyle.append(".apply-form .content .section table tr td input[type='text'] { font-size:16px; border-radius:10px; padding:5px 20px 5px 10px; }");
	customStyle.append(".apply-form .content .section textarea { font-size:16px; border-radius:10px; padding:5px 20px 5px 10px; }");
	customStyle.append(".apply-form .content .section table.buttons { border:none; margin:0px; }");
	customStyle.append(".apply-form .content { box-shadow: 3px 3px 8px 0px #4d7562 }");
	customStyle.append('body { font-family:"Ubuntu", Sans-serif !important; }');
	customStyle.append('.apply-form .content .section table tr td:first-child { font-weight:300; }')
	customStyle.append('.apply-form .content .section.message h3 { font-weight:300; font-size:16px; }')
	customStyle.append('.apply-form .content .section.personal h3 { margin-top:0px; }')
	customStyle.append('.job-header h1 a { font-family:"Ubuntu", Sans-serif !important; }')
	
}

if(env_info.name === 'careerscout'){
	customStyle.append('.apply-form { width:385px !important; overflow:hidden; }');
	customStyle.append('.apply-form .content { background:#094768; border:none; border-radius:0px; font-family: "Raleway", sans-serif; color:#fff; padding-bottom:50px; border-bottom-right-radius:120px; }');
	customStyle.append('.apply-form .content .section h3 { display:none; border-bottom:1px solid #053650; padding-bottom:10px; color:#ef7d2b; }');
	customStyle.append("input[type='text'] { background:#094768; border:1px solid #094768 !important; border-bottom:1px solid #053650 !important; color:#fff; font-size:16px !important; width:335px !important; padding:10px 5px 10px 5px !important; }");
	customStyle.append("textarea { background:#094768; border:1px solid #053650 !important; color:#fff; width:345px !important; }");
	customStyle.append("input[type='file'] { font-size:12px; }");
	
	customStyle.append('.apply-form .content .section.apply input[type="submit"] { width:auto; padding:12px 32px 12px 32px; border-radius:100px 100px 100px 100px; background:#e6545e; border:1px solid #e6545e; font-size:18px; }');
	customStyle.append('.apply-form .content .section.apply input[type="submit"]:hover { background:#094768; border:1px solid #e6545e;}');
	customStyle.append('.apply-form .content .section.apply table { border-top:1px solid #053650;}');
	customStyle.append(".cancel{ display:none; !important }");
	
	customStyle.append('.apply-form .content .section table tbody tr td:first-child { display:none; }');
	customStyle.append('.apply-form .content .section.social table tbody tr td:first-child { display:table; color:#ffffff75; padding-left:5px; }');
	customStyle.append('.apply-form .content .section.apply table tbody tr td:first-child { display:table; }');
	
	customStyle.append('.apply-form .content .section.social { margin-top:15px; }');
	customStyle.append('.apply-form .content .section.message { margin-top:15px; }');
	customStyle.append('.apply-form .content .section.agree-message { margin-top:15px; font-size:12px; }');
	customStyle.append('::placeholder { color:#ffffff75; }')
	
}


if(inIframe()){
	customStyle.append(".apply-form .content { padding:0px; }");
	customStyle.append(".apply-form .content { border:0px; }");
}

customStyle.appendTo('head');
 
// App
var App = React.createClass({
	render: function(){
		
		var job_header = '';
		
		// job_data is json
		if(job_data){
			job_header = (<JobHeader env={form_data.env} job_id={form_data.job_id} title={job_data.title} company_logo={job_data.company_logo} env_info={env_info} job={job_data} />);
		}
		
		// prefill_data is present
		
		if(inIframe()){
			job_header = '';
		}
		
		if(!job_data && !env_info.settings.enable_standard_apply_form){
			return (
				<div className="wrapper">	
					
					<DisabledView />
					
				</div>
			);
		} else {
	    	return (
				<div className="wrapper">	
					
					{job_header}
					
					<ApplyForm env_info={env_info} values={form_data} title={(job_data !== null) ? job_data.title : 'view'} job={job_data} />
					
				</div>
			);
		}
	}
});

// Render app to body
ReactDOM.render(<App />, document.body);

function inIframe () {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}